import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../../components/CustomComponent.js";
import data_province from "../../../assets/files/th_province.json";
export default class Customers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",

      data: [],
      count: 10,

      id: "",
      uid: "",
      customer_code: "",
      prefix_name: "",
      full_name: "",
      address: "",
      phone: "",
      tax_number: "",
      payment_conditions: "",

      cars: [],

      selected_car: -1,
      cuid: "",
      car_type: "",
      car_brand: "",
      car_model: "",
      gear_type: "",
      car_registration: "",
      province: "",
      car_color: "",
      policy_number: "",
      chassis_number: "",
      engine_number: "",
      insurance_company: "",
      image: "",
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("id")) {
      this.GetByID();
    }
  }
  GetByID = async () => {
    loading(true);
    let [result] = await Promise.all([GET("admin/setting/customers/list", { uid: params("id") })]);
    if (result?.status) {
      this.setState({ ...result.data });
    }
    loading(false);
  };
  CreateUpdate = async () => {
    const { uid, customer_code, prefix_name, full_name, address, phone, tax_number, payment_conditions, cars } = this.state;
    if (!prefix_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณาเลือกคำนำหน้า");
      return;
    } else if (!full_name.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกชื่อ-สกุล");
      return;
    } else if (!phone.trim()) {
      alert("", "warning", "แจ้งเตือน", "กรุณากรอกเบอร์โทร");
      return;
    }

    loading(true);
    let body = {
      customer_code,
      prefix_name,
      full_name,
      address,
      phone,
      tax_number,
      payment_conditions,
      cars,
    };

    let result = !uid ? await POST("admin/setting/customers/create", body) : await PUT("admin/setting/customers/update/" + uid, body);
    if (result?.status) {
      alert("#", "success");
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };

  CreateCar = async () => {
    const { uid, cuid, car_type, car_brand, car_model, gear_type, car_registration, province, car_color, policy_number, chassis_number, engine_number, insurance_company, image, cars } = this.state;
    loading(true);
    let body = {
      customer_id: uid,
      car_type,
      car_brand,
      car_model,
      gear_type,
      car_registration,
      province,
      car_color,
      policy_number,
      chassis_number,
      engine_number,
      insurance_company,
      image,
    };
    let result = await POST("admin/setting/customers/create-car", body);
    if (result?.status) {
      alert("#", "success");
      this.GetByID();
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  UpdateCar = async () => {
    const { cuid, car_type, car_brand, car_model, gear_type, car_registration, province, car_color, policy_number, chassis_number, engine_number, insurance_company, image, cars } = this.state;
    loading(true);
    let body = {
      car_type,
      car_brand,
      car_model,
      gear_type,
      car_registration,
      province,
      car_color,
      policy_number,
      chassis_number,
      engine_number,
      insurance_company,
      image,
    };
    let result = await PUT("admin/setting/customers/update-car/" + cuid, body);
    if (result?.status) {
      alert("#", "success");
      this.setState({
        cars: cars.map((item) => (item.uid === cuid ? { ...item, ...body } : item)),
        cuid: "",
        car_type: "",
        car_brand: "",
        car_model: "",
        gear_type: "",
        car_registration: "",
        province: "",
        car_color: "",
        policy_number: "",
        chassis_number: "",
        engine_number: "",
        insurance_company: "",
        image: "",
      });
    } else {
      alert("", "warning", "แจ้งเตือน", result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง");
    }
    loading(false);
  };
  DeleteCar = async (uid) => {
      loading(true);
      let result = await DELETE("admin/setting/customers/delete-car/" + uid, null);
      if (result?.status) {
        alert("#", "success");
        this.setState({ cars: this.state.cars.filter((item) => item.uid !== uid) });
      }
      loading(false);
  };
  render() {
    const { id, uid, customer_code, prefix_name, full_name, address, phone, tax_number, payment_conditions, cars, selected_car, cuid, car_type, car_brand, car_model, gear_type, car_registration, province, car_color, policy_number, chassis_number, engine_number, insurance_company, image } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-2 me-3">ข้อมูลลูกค้า</h4>
              <button
                className="btn btn-outline-dark px-3 ms-auto mb-2 banks.create"
                onClick={async () => {
                  window.location.href = "/setting/customers";
                }}
              >
                ย้อนกลับ
              </button>
            </div>
            {uid && (
              <div className="row mb-3">
              <div className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2">
                <div className="wpx-150 mb-1">รหัสลูกค้า{required}</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="รหัสลูกค้า..."
                  onChange={(e) => {
                    this.setState({ customer_code: e.target.value });
                  }}
                  value={customer_code}
                />
              </div>
              </div>
              )}
            <div className="row mb-3">
              <div className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2">
                <div className="wpx-150 mb-1">คำนำหน้า{required}</div>
                <select
                  className="form-control"
                  placeholder="คำนำหน้า..."
                  onChange={(e) => {
                    this.setState({ prefix_name: e.target.value });
                  }}
                  value={prefix_name}
                >
                  <option value=""></option>
                  <option value="นาย">นาย</option>
                  <option value="นาง">นาง</option>
                  <option value="นางสาว">นางสาว</option>
                  <option value="บริษัท">บริษัท</option>
                </select>
              </div>
              <div className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2">
                <div className="wpx-150 mb-1">ชื่อ-สกุล{required}</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ชื่อ-สกุล..."
                  onChange={(e) => {
                    this.setState({ full_name: e.target.value });
                  }}
                  value={full_name}
                />
              </div>
              <div className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2">
                <div className="wpx-150 mb-1">เบอร์โทร{required}</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เบอร์โทร..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ phone: e.target.value });
                  }}
                  value={phone}
                />
              </div>
              <div className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2">
                <div className="wpx-150 mb-1">เลขที่ผู้เสียภาษี</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เลขที่ผู้เสียภาษี..."
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ tax_number: e.target.value });
                  }}
                  value={tax_number}
                />
              </div>
              <div className="col-6 col-md-4 col-lg-4 col-xl-9 mb-2">
                <div className="wpx-150 mb-1">ที่อยู่</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="ที่อยู่..."
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                  value={address}
                />
              </div>
              <div className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2">
                <div className="wpx-150 mb-1">เงื่อนไขการชำระ</div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="เงื่อนไขการชำระ..."
                  onChange={(e) => {
                    this.setState({ payment_conditions: e.target.value });
                  }}
                  value={payment_conditions}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-6">
                <h4 className="fw-bold mb-2 me-3">ข้อมูลรถ</h4>
                <div className="row">
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">ประเภทรถ</div>
                    <select
                      className="form-control"
                      placeholder="ประเภทรถ..."
                      onChange={(e) => {
                        this.setState({ car_type: e.target.value });
                      }}
                      value={car_type}
                    >
                      <option value=""></option>
                      <option value="รถจักรยานยนต์">รถจักรยานยนต์</option>
                      <option value="รถยนต์">รถยนต์</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">ยี่ห้อรถ</div>
                    <select
                      className="form-control"
                      placeholder="ยี่ห้อรถ..."
                      onChange={(e) => {
                        this.setState({ car_brand: e.target.value });
                      }}
                      value={car_brand}
                    >
                      <option value=""></option>
                      <option value="HONDA">HONDA</option>
                      <option value="TOYOTA">TOYOTA</option>
                      <option value="MAZDA">MAZDA</option>
                      <option value="ISUZU">ISUZU</option>
                      <option value="MITSUBISHI">MITSUBISHI</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">รุ่นรถ</div>
                    <select
                      className="form-control"
                      placeholder="รุ่นรถ..."
                      onChange={(e) => {
                        this.setState({ car_model: e.target.value });
                      }}
                      value={car_model}
                    >
                      <option value=""></option>
                      <option value="A1234">A1234</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">ประเภทเกียร์</div>
                    <select
                      className="form-control"
                      placeholder="ประเภทเกียร์..."
                      onChange={(e) => {
                        this.setState({ gear_type: e.target.value });
                      }}
                      value={gear_type}
                    >
                      <option value=""></option>
                      <option value="AUTO">AUTO</option>
                      <option value="MANUAL">MANUAL</option>
                    </select>
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">ทะเบียนรถ</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="ทะเบียนรถ..."
                      onChange={(e) => {
                        this.setState({ car_registration: e.target.value });
                      }}
                      value={car_registration}
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">จังหวัด</div>
                    <select
                      className="form-control"
                      placeholder="จังหวัด..."
                      onChange={(e) => {
                        this.setState({ province: e.target.value });
                      }}
                      value={province}
                    >
                      <option value=""></option>
                      {data_province.map((item, index) => (
                        <option key={index} value={item.th}>
                          {item.th}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">สีรถ</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="สีรถ..."
                      onChange={(e) => {
                        this.setState({ car_color: e.target.value });
                      }}
                      value={car_color}
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">เลขกรมธรรม์</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="เลขกรมธรรม์..."
                      onChange={(e) => {
                        this.setState({ policy_number: e.target.value });
                      }}
                      value={policy_number}
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">เลขตัวถัง</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="เลขตัวถัง..."
                      onChange={(e) => {
                        this.setState({ chassis_number: e.target.value });
                      }}
                      value={chassis_number}
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">เลขเครื่องยนต์</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="เลขเครื่องยนต์..."
                      onChange={(e) => {
                        this.setState({ engine_number: e.target.value });
                      }}
                      value={engine_number}
                    />
                  </div>
                  <div className="col-6 col-md-4 col-lg-4 mb-2">
                    <div className="wpx-150 mb-1">บริษัทประกัน</div>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="บริษัทประกัน..."
                      onChange={(e) => {
                        this.setState({ insurance_company: e.target.value });
                      }}
                      value={insurance_company}
                    />
                  </div>
                  <div className="col-12 mb-2">
                    <div className="wpx-150 mb-1">อัพโหลดภาพหลักฐาน</div>
                    <div className="d-flex flex-wrap">
                      <input
                        hidden
                        accept="image/*"
                        id="image"
                        type="file"
                        onChange={async (e) => {
                          if (e.target.files[0]) {
                            let _image = await new Promise((resolve) => {
                              Resizer.imageFileResizer(
                                e.target.files[0],
                                1200,
                                1200,
                                "JPEG",
                                100,
                                0,
                                (uri) => {
                                  resolve(uri);
                                },
                                "base64"
                              );
                            });
                            this.setState({ image: _image });
                            e.target.value = "";
                          }
                        }}
                      />
                      {this.state.image ? (
                        <div className="wpx-100 hpx-100 rounded-3 border p-1 position-relative">
                          <img alt="example" src={this.state.image} className="rounded-3" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                          <span
                            className="wpx-20 hpx-20 rounded-circle bg-danger pointer text-white text-16 position-absolute icon d-flex align-items-center justify-content-center shadow"
                            style={{ right: -8, top: -8 }}
                            onClick={() => {
                              this.setState({ image: "" });
                            }}
                          >
                            {"\uf00d"}
                          </span>
                        </div>
                      ) : (
                        <div className="d-flex">
                          <div
                            className="wpx-100 hpx-100 d-flex align-items-center justify-content-center icon text-32 text-success bg-success-light rounded-3 pointer"
                            onClick={() => {
                              document.getElementById("image").click();
                            }}
                          >
                            {"\uf03e"}
                          </div>
                          <small className="text-secondary ps-3">
                            <b>ขนาดไฟล์ที่แนะนำ:</b> ไม่เกิน 1200x1200 พิกเซล เพื่อให้ได้คุณภาพที่ดีที่สุด <br />
                            <b>รูปแบบไฟล์ที่รองรับ:</b> PNG, JPG, JPEG, GIF <br />
                            <b>ขนาดไฟล์สูงสุด:</b> 5MB
                          </small>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-outline-dark px-3 ms-2 mb-2 customers.delete"
                    onClick={async () => {
                      if (await alert("", "warning", "ยืนยันการล้างค่า", "คุณต้องการล้างค่าทั้งหมดหรือไม่?", "ล้างค่า", "ยกเลิก")) {
                        this.setState({ car_type: "", car_brand: "", car_model: "", gear_type: "", car_registration: "", province: "", car_color: "", policy_number: "", chassis_number: "", engine_number: "", insurance_company: "", image: "" });
                      }
                    }}
                  >
                    ล้างค่า
                  </button>
                  <button
                    className="btn btn-dark px-3 ms-2 mb-2 customers.create"
                    onClick={async () => {
                      if (!car_type.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกประเภทรถ");
                        return;
                      } else if (!car_brand.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกยี่ห้อรถ");
                        return;
                      } else if (!car_model.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกรุ่นรถ");
                        return;
                      } else if (!gear_type.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกประเภทเกียร์");
                        return;
                      } else if (!car_registration.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกทะเบียนรถ");
                        return;
                      } else if (!province.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกจังหวัด");
                        return;
                      } else if (!car_color.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกสีรถ");
                        return;
                      } else if (!policy_number.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกเลขกรมธรรม์");
                        return;
                      } else if (!chassis_number.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกเลขตัวถัง");
                        return;
                      } else if (!engine_number.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกเลขเครื่องยนต์");
                        return;
                      } else if (!insurance_company.trim()) {
                        alert("", "warning", "แจ้งเตือน", "กรุณากรอกบริษัทประกัน");
                        return;
                      }
                      if (cuid) {
                        await this.UpdateCar();
                      } else {
                        if(uid) {
await this.CreateCar();
                        }else{
                        if (selected_car !== -1) {
                          cars[selected_car] = {
                            car_type,
                            car_brand,
                            car_model,
                            gear_type,
                            car_registration,
                            province,
                            car_color,
                            policy_number,
                            chassis_number,
                            engine_number,
                            insurance_company,
                            image,
                          };
                          this.setState({
                            cars: [...cars],
                            selected_car: -1,
                            cuid: "",
                            car_type: "",
                            car_brand: "",
                            car_model: "",
                            gear_type: "",
                            car_registration: "",
                            province: "",
                            car_color: "",
                            policy_number: "",
                            chassis_number: "",
                            engine_number: "",
                            insurance_company: "",
                            image: "",
                          });
                        } else {
                          this.setState({
                            cars: [
                              ...cars,
                              {
                                car_type,
                                car_brand,
                                car_model,
                                gear_type,
                                car_registration,
                                province,
                                car_color,
                                policy_number,
                                chassis_number,
                                engine_number,
                                insurance_company,
                                image,
                              },
                            ],
                            selected_car: -1,
                            cuid: "",
                            car_type: "",
                            car_brand: "",
                            car_model: "",
                            gear_type: "",
                            car_registration: "",
                            province: "",
                            car_color: "",
                            policy_number: "",
                            chassis_number: "",
                            engine_number: "",
                            insurance_company: "",
                            image: "",
                          });
                        }
                        }
                      }
                    }}
                  >
                    บันทึกข้อมูล
                  </button>
                </div>
              </div>
              <div className="col-12 col-md-6">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <td>ทะเบียนรถ</td>
                      <td>ยี่ห้อรถ</td>
                      <td>รุ่นรถ</td>
                      <td>สีรถ</td>
                      <td>จังหวัด</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {cars?.map((item, index) => (
                      <tr key={index}>
                        <td className="text-nowrap">{item.car_registration || "-"}</td>
                        <td className="text-nowrap">{item.car_brand || "-"}</td>
                        <td className="text-nowrap">{item.car_model || "-"}</td>
                        <td className="text-nowrap">{item.car_color || "-"}</td>
                        <td className="text-nowrap">{item.province || "-"}</td>
                        <td>
                          <div className="d-flex">
                            <BtnIcon
                              className="customers.update"
                              type="update"
                              onClick={() => {
                                this.setState({
                                  selected_car: index,
                                  cuid: item.uid,
                                  car_type: item.car_type || "",
                                  car_brand: item.car_brand || "",
                                  car_model: item.car_model || "",
                                  gear_type: item.gear_type || "",
                                  car_registration: item.car_registration || "",
                                  province: item.province || "",
                                  car_color: item.car_color || "",
                                  policy_number: item.policy_number || "",
                                  chassis_number: item.chassis_number || "",
                                  engine_number: item.engine_number || "",
                                  insurance_company: item.insurance_company || "",
                                  image: item.image || "",
                                });
                              }}
                            />
                            <BtnIcon
                              className="customers.delete"
                              type="delete"
                              onClick={async () => {
                                if (await alert("", "warning", "ลบข้อมูล", "ยืนยันการลบรายการนี้หรือไม่ ?", "ลบข้อมูล", "ยกเลิก")) {
                                if(item.uid) {
                                this.DeleteCar(item.uid);
                                }else{
                                  this.setState({
                                    cars: cars.filter((carItem, carIndex) => carIndex !== index),
                                    selected_car: -1,
                                    cuid: "",
                                  });
                                }
                              }
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="pt-0 border-0 d-flex justify-content-end">
              <div className="d-flex">
                <button
                  className="btn btn-dark px-5 me-1"
                  onClick={() => {
                    this.CreateUpdate();
                  }}
                >
                  บันทึก
                </button>
                <button
                  className="btn btn-outline-dark px-5 ms-1"
                  onClick={() => {
                    window.location.href = "/setting/customers";
                  }}
                >
                  ยกเลิก
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
